import React, { useState } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function CreateSelectedStudent() {
    const [formval, setFormval] = useState({
        name: "",
        roll_number: "",
        exam: "",
        exam_year: "",
        state: "",
        city: "",
        status: "active",
        photo: null,
    });

    const navigate = useNavigate();

    const ChangeHandler = (e) => {
        const { name, value, files } = e.target;
        if (name === "photo") {
            setFormval((prev) => ({ ...prev, photo: files[0] }));
        } else {
            setFormval((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { name, roll_number, exam, exam_year, state, city, photo } = formval;

        if (!name || !roll_number || !exam || !exam_year || !state || !city) {
            toast.error("All fields are required.");
            return;
        }

        if (!photo) {
            toast.error("Photo is required.");
            return;
        }

        const formData = new FormData();
        formData.append("name", name);
        formData.append("roll_number", roll_number);
        formData.append("exam", exam);
        formData.append("exam_year", exam_year);
        formData.append("state", state);
        formData.append("city", city);
        formData.append("status", formval.status);
        formData.append("photo", photo);

        try {
            const response = await axios.post(`${baseUrl}/selected_student`, formData, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response?.data?.status) {
                toast.success("Student added successfully!", { transition: Bounce });
                navigate("/selected-students"); // Redirect back to the list
            } else {
                toast.error(response.data.message || "Something went wrong");
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || "API error");
        }
    };

    return (
        <section className="main-sec">
            <div className="row">
                <div className="col-lg-12 d-flex justify-content-between align-items-center mb-4">
                    <h4 className="dash-head">
                        <i className="fa fa-user-graduate me-2" />
                        Add Selected Student
                    </h4>
                </div>
                <div className="col-lg-12">
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    placeholder="Name"
                                    value={formval.name}
                                    onChange={ChangeHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    name="roll_number"
                                    className="form-control"
                                    placeholder="Roll Number"
                                    value={formval.roll_number}
                                    onChange={ChangeHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    name="exam"
                                    className="form-control"
                                    placeholder="Exam"
                                    value={formval.exam}
                                    onChange={ChangeHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    name="exam_year"
                                    className="form-control"
                                    placeholder="Exam Year"
                                    value={formval.exam_year}
                                    onChange={ChangeHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    name="state"
                                    className="form-control"
                                    placeholder="State"
                                    value={formval.state}
                                    onChange={ChangeHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    name="city"
                                    className="form-control"
                                    placeholder="City"
                                    value={formval.city}
                                    onChange={ChangeHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="file"
                                    name="photo"
                                    className="form-control"
                                    onChange={ChangeHandler}
                                    accept="image/*"
                                />
                            </div>
                            <div className="col-md-12 text-end mt-3">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary ms-2"
                                    onClick={() => navigate("/selected-students")}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}
